// MM/DD/YYYY format.
export const DATE_MASK = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];